'use client';
import type { ProductsCarouselItem } from "@/types/sections.model";
import { ArrowForward } from "@mui/icons-material";
import { Box, Button, Card, CardMedia, Typography } from "@mui/material";
import Image from "next/image";
import React from "react";


const ProductCard: React.FC<Pick<ProductsCarouselItem, 'image' | 'title'> & { callBack?: () => void, active: boolean }> = ( { image, title, callBack, active = false } ) => {

  return (
    <Card
      onClick={callBack}
      elevation={0}
      className="test"
      sx={{
        borderRadius: 6,
        boxShadow: "none",
        position: "relative",
        minHeight: 360,
        aspectRatio: '421/665',
        cursor: "pointer",
        opacity: active ? 1 : 0.4,
        transition: "opacity 0.3s ease",
        backgroundColor: 'transparent',
        "&:after": {
          content: '""',
          display: "block",
          position: "absolute",
          width: "100%",
          height: "100%",
          bottom: 0,
          zIndex: 1,
          background: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 50%, rgba(0, 0, 0, 0.25) 100%)",
          backgroundBlendMode: 'plus-darker'
        },

        '&:hover': {
          opacity: 1,
        }
      }}
    >
      <CardMedia
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          top: 0,
          left: 0,
          zIndex: 0,
          backgroundPosition: "top",
        }}
      >
        <Image
          src={image}
          alt={title}
          fill
        />
      </CardMedia>

      <Box
        sx={{
          paddingX: 20,
          paddingY: 16,
          position: "absolute",
          zIndex: 2,
          bottom: 0,
          width: "100%",
          color: "common.white",
        }}
      >
        <Typography variant="displaySM" component="div" mb={24} textTransform="uppercase">{title}</Typography>

        <Button variant="text" endIcon={<ArrowForward />} sx={{color: 'white', mt: 2}}>
          <Typography variant="bodyLGSemibold" component="span">Scopri la routine</Typography>
        </Button>
      </Box>
    </Card>
  );
}

export default ProductCard;